import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany } from '@apexdesigner/schema-tools';

export const termTime = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    startTime: z.string().nullable().optional().describe('Start Time'),

    endTime: z.string().nullable().optional().describe('End Time'),

    termId: z.number().hidden().describe('Foreign key to Term'),

    term: belongsTo('Term'),

    slots: hasMany('Slot', 'timeId'),

    attendances: hasMany('Attendance', 'timeId'),
  })
  .describe(
    'A recurring weekly meeting time within a term, whose slots are the assignable units.',
  )
  .as('TermTime');

export { termTime as termTimeSchema };
